 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f":"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f","amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382":"amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382","amazon-lol":"amazon-lol","ea-jedi-survivor":"ea-jedi-survivor","ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea","ea-vgas":"ea-vgas","ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea","ea-vgas-asia":"ea-vgas-asia","ea-vgas-europe":"ea-vgas-europe","ea-vgas-global":"ea-vgas-global","ea-vgas-japan":"ea-vgas-japan","ea-vgas-na":"ea-vgas-na","ea-vgas-south-korea":"ea-vgas-south-korea","ea-wildhearts":"ea-wildhearts","hp-nvidia":"hp-nvidia","itt":"itt","madden23":"madden23","ogh":"ogh","polaris-bf2042":"polaris-bf2042","prestonplayz":"prestonplayz","rockstar-energy":"rockstar-energy","ea-saberhunt":"ea-saberhunt","battlefield2042":"battlefield2042","challenge-response":"challenge-response"}[chunkId]||chunkId) + "." + {"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f":"2b7190f5","amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382":"4a5f7df2","amazon-lol":"bae56412","ea-jedi-survivor":"f728d7c9","ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"b6439d32","ea-vgas":"f1f7b9e5","ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"d21645bb","ea-vgas-asia":"bacc42dd","ea-vgas-europe":"952dc4df","ea-vgas-global":"e37190a1","ea-vgas-japan":"a299cb6f","ea-vgas-na":"ae8523fd","ea-vgas-south-korea":"753c008d","ea-wildhearts":"9dbcae23","hp-nvidia":"3fccc42e","itt":"9e1cbdd9","madden23":"451892e9","ogh":"9831499c","polaris-bf2042":"d6b703f8","prestonplayz":"a8d782d8","rockstar-energy":"c21f674f","ea-saberhunt":"7f1c1b7a","battlefield2042":"6f170702","challenge-response":"83ca8978"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"amazon-lol":1,"ea-jedi-survivor":1,"ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":1,"ea-wildhearts":1,"hp-nvidia":1,"itt":1,"madden23":1,"ogh":1,"polaris-bf2042":1,"prestonplayz":1,"rockstar-energy":1,"ea-saberhunt":1,"battlefield2042":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f":"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f","amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382":"amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382","amazon-lol":"amazon-lol","ea-jedi-survivor":"ea-jedi-survivor","ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea","ea-vgas":"ea-vgas","ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea","ea-vgas-asia":"ea-vgas-asia","ea-vgas-europe":"ea-vgas-europe","ea-vgas-global":"ea-vgas-global","ea-vgas-japan":"ea-vgas-japan","ea-vgas-na":"ea-vgas-na","ea-vgas-south-korea":"ea-vgas-south-korea","ea-wildhearts":"ea-wildhearts","hp-nvidia":"hp-nvidia","itt":"itt","madden23":"madden23","ogh":"ogh","polaris-bf2042":"polaris-bf2042","prestonplayz":"prestonplayz","rockstar-energy":"rockstar-energy","ea-saberhunt":"ea-saberhunt","battlefield2042":"battlefield2042","challenge-response":"challenge-response"}[chunkId]||chunkId) + "." + {"amazon-lol~ea-jedi-survivor~ea-saberhunt~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-~7f94c12f":"31d6cfe0","amazon-lol~ea-jedi-survivor~ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas~9425d382":"31d6cfe0","amazon-lol":"71fb0e50","ea-jedi-survivor":"753f948f","ea-vgas~ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"a381c563","ea-vgas":"31d6cfe0","ea-vgas-asia~ea-vgas-europe~ea-vgas-global~ea-vgas-japan~ea-vgas-na~ea-vgas-south-korea":"31d6cfe0","ea-vgas-asia":"31d6cfe0","ea-vgas-europe":"31d6cfe0","ea-vgas-global":"31d6cfe0","ea-vgas-japan":"31d6cfe0","ea-vgas-na":"31d6cfe0","ea-vgas-south-korea":"31d6cfe0","ea-wildhearts":"db6ff261","hp-nvidia":"87ad9295","itt":"7957952c","madden23":"fcbf2996","ogh":"4a12ca2d","polaris-bf2042":"dc137a64","prestonplayz":"728d1780","rockstar-energy":"80e148cf","ea-saberhunt":"d0f1c48e","battlefield2042":"bde5f831","challenge-response":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
